import React from 'react'
import { IconButton } from 'utoniq-ui'

import { BaseLayout, Head } from '@/components/layouts'
import { useRouter, useTranslation } from '@/core'
import { Template } from '@/core/architecture'

import type { PasswordSettingFormProps } from './PasswordSettingForm'
import { PasswordSettingForm } from './PasswordSettingForm'
import type { UnregisteredPasswordSettingFormProps } from './UnregisteredPasswordSettingForm'
import { UnregisteredPasswordSettingForm } from './UnregisteredPasswordSettingForm'
import type { WalletPasswordSettingFormProps } from './WalletPasswordSettingForm'
import { WalletPasswordSettingForm } from './WalletPasswordSettingForm'

export * from './fragments'

export type State = {
  hasPassword: boolean
  forWallet: boolean
  email?: string | null
}

export type Action = {
  onSubmit: PasswordSettingFormProps['onSubmit']
  onSubmitUnregisteredPassword: UnregisteredPasswordSettingFormProps['onSubmit']
  onSubmitWalletPassword: WalletPasswordSettingFormProps['onSubmit']
  onClose?: () => void
}

export const PasswordSettingsTemplate: Template<State, Action> = ({
  state,
  onSubmit,
  onSubmitUnregisteredPassword,
  onSubmitWalletPassword,
  onClose,
}) => {
  const { t } = useTranslation('passwordSettings')
  const { routerNames, routerPages } = useRouter()
  return (
    <BaseLayout
      margin
      header={{
        title: t('title'),
        back: !onClose,
        defaultBackPage: routerPages.AccountSetting,
        left: onClose && <IconButton.Close onClick={onClose} sx={{ ml: -2 }} />,
      }}
    >
      <Head title={routerNames.PasswordSetting} />
      {!state?.forWallet ? (
        state?.hasPassword ? (
          <PasswordSettingForm onSubmit={onSubmit} />
        ) : (
          <UnregisteredPasswordSettingForm
            onSubmit={onSubmitUnregisteredPassword}
          />
        )
      ) : null}
      {state?.forWallet && (
        <WalletPasswordSettingForm
          email={state.email}
          onSubmit={onSubmitWalletPassword}
          onClose={onClose}
        />
      )}
    </BaseLayout>
  )
}
